import apiService from "./globalService"

export const SocialNetworksService = ()=> {
    return {
        getLinks: () => {
            return apiService.get(`/wp-json/social-networks/v1/list`);
        }
    }   
}
